import React, {Component} from 'react';
import profilePic from '../images/png/profilePicture.png';
import logo from '../images/png/SF-Logo.png';
import logoSVG from '../images/svg/logo.svg'
import apiRequestService from '../components/ApiRequestService';
import Properties from '../components/Properties';
import QMlogo from '../images/png/EQM.png';
import { AppSetting , AppProperties } from '../common/functions';

//CSS
import '../css/UserProfile.css';
import styles from '../css/styles.css.js';

export default class UserProfile extends Component {
  AppSetting = AppSetting();
  appProperties = AppProperties();

  universitySuffix = this.AppSetting && this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX 
  ? (this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX.includes("lti") ? this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX.replace("_lti", "(carmen)") : this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX)
  : ""  

  logout = () => {
    if (this.appProperties.enableLogin) {
    /*  apiRequestService({
        method: 'post',
        url: '/logout'
      }).then(token => {*/
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'token', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'GivenName', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'USER_NAME', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'UnixEpoch', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'emailid', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'OSUID', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX+"_"+'role', '');
        window.localStorage.setItem('isLTIStudent', '');
        window.location.reload();
        //let tempUserProfile = this.state.userProfile;
      //  tempUserProfile.isLoggedIn = false;
      //  this.setState({ userProfile: tempUserProfile });
      //});
    }
  };

    render()
    {
        
        let roles = ['Student','Instructor','Administrator'];
            return <div  name="UserHeader" className="bg-color-secondary" style={{background:"#666666",height:"max-content"}}>
            <div style={styles.drawerTitleColor}>
                {this.props.eqmMode?
                  <div className="bg-color-primary"><img className="image-fit-width" alt="EQM" title="EQuizMaster" src={QMlogo} >
                    </img></div>
                    :                    
                  (this.props.loginType === 'form'?
                          <div className="bg-color-primary"><img className="image-fit-width" alt="Stem Fluency" title="Stem Fluency" src={logo} ></img></div>:
                          <div className="bg-color-primary"><img className="image-fit-width" alt="Essential Skills" title="Essential Skills" src={logoSVG} ></img></div>
                )
                }
                </div>
                             <div>   
                                <div  className="userProfile-container" style={{
                              display:"flex",
                              justifyContent:"start",
                              alignItems:"center"
                             }}>
                                    <div className="userProfile-image-box">
                                        <img  className="image-fit-width avatar" src={profilePic} alt="Profile Picture" title="Profile Picture" /> 
                                    </div>
                                    <ul className="userProfile-text-box">
                                        <li className="text-color-white text-size-normal">{this.props.givenName}</li>
                                        <li className="text-color-white text-size-small">{roles[this.props.userRole]}, <small>{this.universitySuffix.toUpperCase()}</small></li>
                                        {this.appProperties.enableLogin ? (
                                           <button style={styles.logout_button} onClick={this.logout}>Logout</button>

                                        ) : (
                                          ''
                                        )}
                                    </ul>
                                </div>
                             </div> 
                    </div>;
    }
}

